import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getMemberAll } from '../services/dbService';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import Membersmodal from './membersmodal';
import { getByLinkedMemberByPrimaryMember } from '../store/slices/userSlice';
import { getLinkedMemberAll } from '../store/slices/userSlice';

function Linkedmembersall() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selectedMember, setSelectedMember] = useState(null);


  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      if (localStorage.getItem('role') == 'admin') {
        const response = await getLinkedMemberAll();
        setData(Array.isArray(response?.data) ? response.data : []);
      }
      else {
        var member = localStorage.getItem('id');
        const response = await getByLinkedMemberByPrimaryMember(member)
        setData(Array.isArray(response?.data) ? response.data : []);
      }


    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try {
      const id = localStorage.getItem('id');
      setId(id);
      fetchData();
    } catch (error) {
      console.error('Error in useEffect:', error);
    }
  }, []);
  
  const handleEdit = (item) => {
    try {
      setSelectedMember(item);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error in handleEdit:', error);
    }
  };
  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                  <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Linked Members</h4>
                       
                      </div>
                    </div>
                    <div className="card-body">
                        {localStorage.getItem('role') === 'member' && (
                          <button className="btn btn-info btn-sm me-2 " onClick={() => setIsModalOpen(true)}>
                            New
                          </button>
                        )}
                      
                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "number",
                                "firstname",
                                "lastname",
                                "email",
                                "mobile",
                                "addressline1",
                                "addressline2",
                                "addressline3",
                                "state",
                                "zipcode",
                                "status",
                              ]}
                              data={data}
                              onEdit={handleEdit}
                              showedit={true}
                              showuseredit={true}

                            />
                           
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <Membersmodal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    reloadData={fetchData}
                    selectedMember={selectedMember}
                    primarymember={id}
                    edit="true"
                    type="linked"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Linkedmembersall;
